import * as React from 'react';

function SvgFacebookIcon(props) {
  return (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
      <circle cx={16} cy={16} r={16} fill="#000" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.87 16.066v8.117c0 .132.097.198.194.198h2.97c.13 0 .194-.099.194-.198v-8.249h2.13c.097 0 .194-.099.194-.198l.194-2.475c0-.131-.097-.23-.194-.23h-2.324v-1.75c0-.428.323-.758.742-.758h1.647c.129 0 .194-.1.194-.198V7.817c0-.099-.097-.198-.194-.198H16.84c-1.646 0-2.97 1.353-2.97 3.036v2.409h-1.485c-.097-.034-.194.066-.194.164v2.475c0 .132.097.198.194.198h1.485v.165z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgFacebookIcon;
